
























































import { Prop, Component, Vue } from "vue-property-decorator";

import TextSanitized from "@/common/components/atoms/TextSanitized.vue";

@Component({
  components: {
    TextSanitized
  }
})
export default class TheC01ItemDetail extends Vue {
  @Prop({ type: String, required: false, default: "" }) commentIndex!: string;
  @Prop({ type: String, required: false, default: "" })
  commentDetailMain!: string;
  @Prop({ type: String, required: false, default: "" })
  commentDetailSub!: string;
  @Prop({ type: String, required: false, default: "" })
  commentDetailSubSecond!: string;
  @Prop({ type: String, required: false, default: "" }) janCode!: string;
  @Prop({ type: String, required: false, default: "" }) saleStartDate!: string;
  @Prop({ type: String, required: false, default: "" }) saleEndDate!: string;
  @Prop({ type: String, required: false, default: "" }) category!: string;
  @Prop({ type: String, required: false, default: "" }) categoryChild!: string;
}
